import _ from 'lodash';
import {createStore, applyMiddleware, compose} from 'redux';
import Immutable from 'immutable';
import {browserHistory} from 'react-router';
import {routerMiddleware} from 'react-router-redux';
import multi from 'redux-multi';
import thunk from 'redux-thunk';
import {batchedSubscribe} from 'redux-batched-subscribe';
import GoogleAnalytics from 'react-ga';


let getDebugSessionKey = () => {
    const matches = window.location.href.match(/[?&]debug_session=([^&#]+)\b/);
    return (matches && matches.length > 0) ? matches[1] : null;
};

const googleAnalyticsOptions = {};

const trackPage = page => {
    GoogleAnalytics.set({page, ...googleAnalyticsOptions});
    GoogleAnalytics.pageview(page);
};

const setUser = user => {
    googleAnalyticsOptions.userId = user.id;
    GoogleAnalytics.set({userId: user.id});
};

let currentPage = '';

export const googleAnalytics = () => next => action => {
    if (action.type === '@@router/LOCATION_CHANGE') {
        const nextPage = `${action.payload.pathname}${action.payload.search}`;

        if (currentPage !== nextPage) {
            currentPage = nextPage;
            trackPage(nextPage);
        };
    }
    else if (action.type === 'MAIN_SET_USER') {
        setUser(action.payload);
    }

    return next(action);
};

export default function configureStore(initialState) {
    let enhancers;
    if (process.env.NODE_ENV === 'production') {
        // GoogleAnalytics.initialize('UA-221049917-1');
        enhancers = compose(
            applyMiddleware(
                multi,
                thunk,
                routerMiddleware(browserHistory),
                googleAnalytics,
            ),
            batchedSubscribe(_.debounce(notify => notify())),
        );
    }
    else {
        let {persistState} =  require('redux-devtools');
        // let DevTools = require('./containers/DevTools.jsx');
        enhancers = compose(
            applyMiddleware(
                multi,
                thunk,
                routerMiddleware(browserHistory),
            ),
            window.devToolsExtension ? window.devToolsExtension({maxAge: 500}) : a => a,
            // DevTools.instrument(),
            persistState(
                getDebugSessionKey(),
                data => Immutable.fromJS(data),
            ),
            batchedSubscribe(_.debounce(notify => notify())),
        );
    }
    const store = createStore(
        require('./reducer').default,
        Immutable.fromJS(initialState),
        enhancers,
    );
    if (module.hot && module.hot.onUpdate) {
        module.hot.onUpdate(() => {
            store.replaceReducer(require('./reducer').default);
            return true;
        });
    }
    return store;
};
